import React, { useContext, useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { FaBox, FaShoppingBag, FaUsers, FaTags, FaChartLine } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import AdminNav from '../../components/AdminNav';
import api from '../../utils/api';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user } = useContext(AuthContext);
  const [stats, setStats] = useState({
    products: 0,
    orders: 0,
    categories: 0,
    totalRevenue: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [productsRes, ordersRes, categoriesRes] = await Promise.all([
        api.get('/products'),
        api.get('/orders'),
        api.get('/categories')
      ]);

      const totalRevenue = ordersRes.data.reduce((sum, order) => sum + order.totalPrice, 0);

      setStats({
        products: productsRes.data.length,
        orders: ordersRes.data.length,
        categories: categoriesRes.data.length,
        totalRevenue: totalRevenue
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setLoading(false);
    }
  };

  // Redirect if not admin
  if (!user || !user.isAdmin) {
    return <Navigate to="/login" />;
  }

  if (loading) {
    return <div className="admin-loading">Loading dashboard...</div>;
  }

  const statCards = [
    { icon: <FaBox />, label: 'Total Products', value: stats.products, link: '/admin/products', color: '#C07A5F' },
    { icon: <FaShoppingBag />, label: 'Total Orders', value: stats.orders, link: '/admin/orders', color: '#2D2D2D' },
    { icon: <FaTags />, label: 'Categories', value: stats.categories, link: '/admin/categories', color: '#E5DCC3' },
    { icon: <FaChartLine />, label: 'Revenue', value: `$${stats.totalRevenue.toFixed(2)}`, link: '#', color: '#C07A5F' }
  ];

  return (
    <>
      <AdminNav />
      <div className="admin-dashboard">
        <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <p>Welcome back, {user?.name}</p>
      </div>

      <div className="stats-grid">
        {statCards.map((card, index) => (
          <Link to={card.link} key={index} className="stat-card" style={{ '--accent-color': card.color }}>
            <div className="stat-icon">{card.icon}</div>
            <div className="stat-content">
              <h3>{card.value}</h3>
              <p>{card.label}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="admin-actions">
        <h2>Quick Actions</h2>
        <div className="action-cards">
          <Link to="/admin/products/new" className="action-card">
            <FaBox />
            <h3>Add New Product</h3>
            <p>Create a new product listing</p>
          </Link>
          <Link to="/admin/categories" className="action-card">
            <FaTags />
            <h3>Manage Categories</h3>
            <p>Add or edit product categories</p>
          </Link>
          <Link to="/admin/orders" className="action-card">
            <FaShoppingBag />
            <h3>View Orders</h3>
            <p>Manage customer orders</p>
          </Link>
          <Link to="/admin/users" className="action-card">
            <FaUsers />
            <h3>Manage Users</h3>
            <p>Create admins and manage users</p>
          </Link>
        </div>
      </div>
      </div>
    </>
  );
};

export default AdminDashboard;
